import * as React from 'react'
interface Props {
    title: string
}
export const RowTitle = (props: Props) => <h3 className="row-title">{props.title}</h3>
